export default __webpack_public_path__ + "static/media/ZahrahforDouglasW04-SmBd.b01fed75.woff2";